<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
:root {
  --color-primary: #409EFF;
  --color-primary-hover: #66b1ff;
  --color-primary-soft: #ecf5ff;
  --color-sidebar: #1f2d3d;
  --color-sidebar-dark: #1a2533;
  --color-sidebar-text: #bfcbd9;
  --color-sidebar-text-active: #ffffff;
  --color-page-bg: #f0f2f5;
  --color-card: #ffffff;
  --color-border: #e4e7ed;
  --color-text: #303133;
  --color-text-secondary: #606266;
  --color-text-muted: #909399;
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --space-xs: 8px;
  --space-sm: 12px;
  --space-md: 16px;
  --space-lg: 24px;
  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.06);
  --shadow-md: 0 4px 16px rgba(15, 23, 42, 0.08);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
    -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  background: var(--color-page-bg);
}

#app {
  height: 100%;
}

/* 全局滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #909399;
}
::-webkit-scrollbar-track {
  background: transparent;
}
</style>
